import { Controller } from "@hotwired/stimulus";
import DateHelper from "../src/timeAgoInWords";

export default class extends Controller {
  static targets = ["closesIn"];

  connect() {
    if (this.element.classList.contains("active") && this.data.get("closesAt")) {
      this.updateClosesAt();
      this.startRefreshingClosesAt();
    }
  }

  disconnect() {
    this.stopRefreshingClosesAt();
  }

  startRefreshingClosesAt() {
    this.closesAtRefreshTimer = setInterval(() => {
      this.updateClosesAt();
    }, 10000);
  }

  // The server owns the closed copy (a plain "Closed." and "Closed, required
  // responses met" are different sentences it decides between). This timer
  // only knows the countdown ran out, so it may stop itself once the poll
  // is no longer active or its time has passed, but it never writes a
  // closed string of its own - the broadcast replace/morph that closes the
  // poll brings the right text with it.
  updateClosesAt() {
    if (!this.element.classList.contains("active")) {
      this.stopRefreshingClosesAt();
      return;
    }

    const closesAt = this.data.get("closesAt");
    if (!DateHelper.future(closesAt)) {
      this.stopRefreshingClosesAt();
      return;
    }

    this.closesInTarget.innerHTML = `Closes in ${DateHelper.time_ago_in_words_with_parsing(closesAt)}.`;
  }

  stopRefreshingClosesAt() {
    if (this.closesAtRefreshTimer) {
      clearInterval(this.closesAtRefreshTimer);
    }
  }
}
